export default {"src":"/_next/static/media/hcl.e36e0311.svg","height":42,"width":296,"blurWidth":0,"blurHeight":0};